/**
 * @description 业务上报 灯塔
 */

import { loadScript } from './util';

const isBeaconTest =  location.href.indexOf('test.m.v.qq.com') > -1 || location.href.indexOf('test=1') > -1;

// 灯塔sdk url
const beaconUrl = {
  test: {
    http: '//3gimg.qq.com/mig_op/beacon/js/beacon_release_jrlt.js?appkey=JS0BMFHH3SK2L0&vc=1.0.1',
    https: '//3gimg.qq.com/mig_op/beacon/js/beacon_release_jrlts.js?appkey=JS0BMFHH3SK2L0&vc=1.0.1',
  },
  prod: {
    http: '//3gimg.qq.com/mig_op/beacon/js/beacon_release.js?appkey=JS0BMFHH3SK2L0&vc=1.0.1',
    https: '//3gimg.qq.com/mig_op/beacon/js/beacon_release_s.js?appkey=JS0BMFHH3SK2L0&vc=1.0.1',
  },
};

// 灯塔事件id
const beaconConfig = {
  user_interact: 122017,
};

let isBeaconSDKLoaded = false;
const getBeaconSdkUrl = () => {
  if (isBeaconTest) {
    // 测试环境/开发环境 实时联调
    return location.protocol === 'http:' ? beaconUrl.test.http : beaconUrl.test.https;
  }
  return location.protocol === 'http:' ? beaconUrl.prod.http : beaconUrl.prod.https;
};
const beaconSdkUrl = getBeaconSdkUrl();

const loadBeaconSdk = (url: string) => new Promise((resolve) => {
  if (!isBeaconSDKLoaded) {
    return loadScript(url).then(() => {
      console.log('loaded...');
      isBeaconSDKLoaded = true;
    });
  }
  resolve();
});

let baseBeaconReportData = {
  type: '',
  tplid: '',
  widgetid: '',
  compid: '',
  branchid: '',
  dramaid: '',
  vid: '',
  vuserid: '',
  x: '',
  y: '',
};

const beaconCache: Array<any> = [];
export const beacon = (param: any) => {
  const data = { ...baseBeaconReportData, ...param };
  Object.keys(data).forEach((k) => {
    if (data[k] && typeof data[k] === 'string') {
      data[k] = data[k]
        .replace(/\||\t|\r|\n/gi, ' ')
        .replace(/=/g, '%3D')
        .replace(/&/g, '%26');
    }
  });
  if (window.BeaconAction?.onEvent) {
    window.BeaconAction.onEvent(beaconConfig.user_interact, 'user_interact', data);
  } else {
    beaconCache.push(data);
    loadBeaconSdk(beaconSdkUrl).then(() => {
      beaconCache.forEach((d) => {
        window.BeaconAction.onEvent(beaconConfig.user_interact, 'user_interact', d);
      });
    });
  }
};

export const initBeaconData = (data: any) => {
  baseBeaconReportData = { ...baseBeaconReportData, ...data };
  return baseBeaconReportData;
};
